/** AuthBranch branch */
export const AUTH = '/auth';
/** AuthBranch routes */
export const LOGIN = `${AUTH}/login`;
export const FORBIDDEN = `${AUTH}/forbidden`;
export const FORGOT_PASSWORD = `${AUTH}/forgot`;

/** Log route */
export const LOG = '/';

/** Entry routes */
export const ADD_POST = '/post';
export const POST = '/post/:postId';
export const ADD_ENTRY = '/post/:postId/entry';
export const ENTRY = '/post/:postId/entry/:entryId';
